import optionsJSON from "../client/data/options.json";
import cardsJSON from "../client/data/cards.json";
import { Path, Options } from "./interfaces";

export const options: Options.IOptions = optionsJSON;

export const cards: Path.ICard[] = cardsJSON;

/** Initializes the configuration and user setting json file.
 * @returns true if successful (json file validation was A-OK)
 */
export function init(): boolean {

   if (validInputSettings()) {

      formatInputSettings();

      return true;

   } else {

      return false;

   }

}


/** Formats the input setting data. */
function formatInputSettings(): void {
   cards.forEach((card: Path.ICard) => {
      card.content.forEach((cont: Path.IContent) => cont.type = cont.type.toLowerCase());
   });
}

/** Validates the input setting data.
 * @returns whether the input setting data is valid or not
 */
function validInputSettings(): boolean {
   const invalidCards: Array<{ pageID: string, errors: string[] }> = [];

   cards.forEach((card: Path.ICard) => {
      let usesCustomCard: boolean = false;
      const cardErrors: string[] = [];

      // if the card content is a custom HTML page, flag it
      card.content.some((content: Path.IContent) => {
         if (content.type === "custom_template") {
            usesCustomCard = true;
            return true as any;
         }
      });

      // page can only have one custom content on page
      if (usesCustomCard && card.content.length > 1) {
         cardErrors.push("Page can only have one custom content piece.");
      }

      // if there are errors with this page > log it to pages error array
      if (cardErrors.length > 0) {
         invalidCards.push({ pageID: card.id, errors: cardErrors });
      }
   });

   if (invalidCards.length > 0) {
      // settings are invalid
      console.log("Errors with input settings on pages: ", invalidCards);
      return false;
   } else {
      // setting are valid
      return true;
   }
}


/** Gets the card info based on its ID (filename) */
export function getCard(id: string): Path.ICard | null {
   let cardFound: Path.ICard | null = null;
   // cards.find((card: Path.ICard) => id === card.id);
   cards.forEach((card) => {
      if (id === card.id) {
         cardFound = card;
         return;
      }
   });
   return cardFound;
}